export default "__VITE_ASSET__DeFL5$Xa__"